import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class EmployeeInvitationValidator {

    email = [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(255),
        Validators.email
    ];

    full_name = [
        Validators.required,
        // Validators.pattern('^[a-zA-Z]+$')
    ];

    urole_id = [
        Validators.required
    ]

    // Error messages
    errorMessages = {
        email: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            {
                type: 'minlength',
                message: 'MESSAGES.ONLY_ENG_ALLOWED',
                option: null
            },
            {
                type: 'maxlength',
                message: 'MESSAGES.ONLY_ENG_ALLOWED',
                option: null
            },
            {
                type: 'email',
                message: 'MESSAGES.ONLY_ENG_ALLOWED',
                option: null
            }
        ],
        full_name: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        urole_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
    }
}